import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kiosk.final');
import { OnInit, Input } from "@angular/core";
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-kiosk-final',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kiosk.final/view.scss */
/* src/app/portal.kiosk.final/view.scss: no such file or directory */`],
})
export class PortalKioskFinalComponent implements OnInit {
    @Input() event: any;
    public selectedQuizzes: any[] = [];
    public num: number = 0;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const all = this.event.get("quiz") || [];

        // 틀린 문제만 필터링하면서 원래 인덱스 기록
        this.selectedQuizzes = all
            .map((quiz, idx) => ({ ...quiz, originalIndex: idx }))
            .filter(q => q.response !== q.answer);

        await this.service.render();
    }

    public async nextByConfirm() {
        if (this.num + 1 < this.selectedQuizzes.length) {
            this.num++;
            await this.service.render();
        } else {
            this.event.view("main"); // 마지막 문제 후 main으로
        }
    }

    public getAnswerLabel(quiz: any): string {
        if (!quiz.options || quiz.type !== 'multiple') return '';
        const index = quiz.options.indexOf(quiz.answer);
        return index >= 0 ? ['A', 'B', 'C', 'D'][index] : '';
    }

}

export default PortalKioskFinalComponent;